import React from 'react';
import { createPortal } from 'react-dom';
import { AudienceLevel, Cohort } from '../../types/pathway';
import { PathwayDocument } from './PathwayDocument';
interface PrintSurfaceProps {
  pathwayName: string;
  company: string;
  cohort: Cohort | null;
  audience: AudienceLevel | 'any';
  items: string[];
  fields: string[];
}

/**
 * Renders the full document straight into <body> so the browser's print
 * pipeline can see it. Hidden on screen; the print stylesheet in index.css
 * hides everything else and lets only this through.
 */
export function PrintSurface(props: PrintSurfaceProps) {
  if (typeof document === 'undefined') return null;
  return createPortal(<div className="pathway-print-root" aria-hidden="true" data-id="element-1727" data-mp="ogi4xva1osen">
      <PathwayDocument {...props} data-id="element-1728" data-mp="sefvb1fjxkjm" />
    </div>, document.body);
}

/** Opens the browser print dialog, where the rep chooses "Save as PDF". */
export function printPathwayDocument(pathwayName: string): void {
  const previousTitle = document.title;
  // Chrome and Safari seed the suggested filename from the document title.
  document.title = (pathwayName || 'Recommended Learning Pathway').trim();
  const restore = () => {
    document.title = previousTitle;
    window.removeEventListener('afterprint', restore);
  };
  window.addEventListener('afterprint', restore);
  window.print();
  // Safari does not always fire afterprint, so restore on the next tick too.
  window.setTimeout(restore, 1000);
}